/**
 * Truncate long player names for mobile display
 * Examples:
 * "Muhammad SagOr Alii" → "Muhammad S."
 * "Emtiaz Mahmud Sifat" → "Emtiaz S."
 * "Bhubon" → "Bhubon"
 */
export function truncateName(name: string, maxLength: number = 15): string {
  if (!name) return 'TBD';
  
  const parts = name.trim().split(/\s+/);
  
  // Single word - return as is
  if (parts.length === 1) {
    return name.length > maxLength ? name.slice(0, maxLength - 1) + '.' : name;
  }
  
  // Multiple words - first name + last initial
  const firstName = parts[0];
  const lastName = parts[parts.length - 1];
  const truncated = `${firstName} ${lastName.charAt(0).toUpperCase()}.`;
  
  // If still too long, just truncate
  if (truncated.length > maxLength) {
    return firstName.slice(0, maxLength - 2) + '..';
  }
  
  return truncated;
}
